import { NgForm } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { RouteNavigationService } from '../../../services/api/route-navigation.service';
import { NotificationService, PMVAuthenticationService, DetailComponent, Column, Action, LazyLoadEvent, Combobox } from 'pmv-common';
import { ActivatedRoute, } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { PublicacaoService } from '../../../services/publicacao.service';
import { EditalArquivosInscricao } from '../../../models/editalArquivosInscricao';
import { ArquivoInscricao } from '../../../models/arquivoInscricao';
import { InscricaoService } from '../../../services/inscricao.service';
import { Inscricao } from '../../../models/inscricao-model';

@Component({
  selector: 'pmv-candidato-enviar-arquivo',
  templateUrl: './candidato-enviar-arquivo.component.html',
  styleUrls: ['./candidato-enviar-arquivo.component.scss']
})

export class CandidatoEnviarArquivoComponent extends DetailComponent implements OnInit {
  title: string;
  loading: Boolean = false;
  mostrar: Boolean = true;
  inscricao: Inscricao;
  descricao: string;
  urlApiArquivo: string = 'https://arquivos.vitoria.es.gov.br/api/v1/files/';

  columns: Column[];
  actions: Action[];

  editalArquivos: EditalArquivosInscricao = new EditalArquivosInscricao();
  listaArquivos: ArquivoInscricao[] = [];
  anexo: ArquivoInscricao = new ArquivoInscricao();

  nomeArquivo: string = '';
  arquivo: File;
  arquivos: File[] = [];
  editalAnoPss: string;
  tipoArquivoOptions: Combobox[];

  constructor(
    private readonly notificationService: NotificationService,
    private routeDataService: RouteNavigationService,
    private route: ActivatedRoute,
    private authenticationService: PMVAuthenticationService,
    private publicacaoService: PublicacaoService,
    private inscricaoService: InscricaoService
  ) { super(route); }

  ngOnInit() {
    this.Getinfos();
    Date.prototype.toJSON = function () { return this.toLocaleString('en-US'); }
  }

  Getinfos() {
    this.isAuth();

    this.inscricao = this.routeDataService.getDataCandidatoEnviarArquivo();
    if (!this.inscricao) {
      return this.routeDataService.fromPainelCandidatoToAcompanhamento();
    }
    this.title = 'Consultar/Enviar arquivos/documentos para o Edital selecionado.';
    this.getArquivosByCodigoInscricao();
    this.setupTable();
    this.loadData();
    this.loading = false;
  }

  loadData() {
    // -Lista  566
    this.tipoArquivoOptions = [
      { descricao: 'Qualificação Profissional Inscrição', id: 7 },
      { descricao: 'Declaração de Tempo de Serviço', id: 8 },
      { descricao: 'Comprovante de Escolaridade', id: 9 },
      { descricao: 'Ficha de Cadastro', id: 10 },
      { descricao: 'Ficha Familiar', id: 11 },
      { descricao: 'Formulário de Acúmulo de Cargo Público', id: 12 },
      { descricao: 'Declaração de Bens e Valores', id: 13 },
      { descricao: 'Termo de Adesão – Recebimento de Proventos', id: 14 },
      { descricao: 'RG (frente e verso) ', id: 15 },
      { descricao: 'Situação Cadastral CPF ', id: 16 },
      { descricao: 'Quitação Eleitoral', id: 17 },
      { descricao: 'Certidão de Nascimento ou Casamento – servidor ', id: 18 },
      { descricao: 'CPF Cônjuge', id: 19 },
      { descricao: 'Certidão de Nascimento – filhos', id: 20 },
      { descricao: 'CPF – filhos', id: 21 },
      { descricao: 'Situação Militar', id: 22 },
      { descricao: 'Comprovante de Residência', id: 23 },
      { descricao: 'PIS/PASEP', id: 24 },
      { descricao: 'Qualificação Cadastral – Esocial', id: 25 },
      { descricao: 'Carteira Conselho', id: 26 },
      { descricao: 'Declaração de Acúmulo – Decreto 17.953/2019', id: 27 },
      { descricao: 'Atestado de Saúde Ocupacional / Laudo Médico', id: 28 },
    ];
  }

  isAuth() {
    const canActivate = this.authenticationService.isUserLoggedIn();
    if (canActivate) {
      const tk = this.authenticationService.getToken();
      this.loading = false;
    } else {
      this.authenticationService.redirectToLoginPage();
    }
  }

  getArquivosByCodigoInscricao() {

    this.loading = true;
    this.editalArquivos = new EditalArquivosInscricao();

    this.inscricaoService.GetArquivosInscricaobyId(this.inscricao).subscribe(
      response => {
        this.editalArquivos = response;
        this.listaArquivos = this.editalArquivos.arquivos;
        this.editalAnoPss = 'Edital ' + this.editalArquivos.numeroAnoEdital + ' - ' + this.editalArquivos.cargoCargaHoraria;
        this.mostrar = true;
        this.loading = false;
      }, error => {
        this.loading = false;
        throw error;
      });
  }

  validaArquivo(event) {
    if (this.arquivo.size > 3745728) {
      this.notificationService.notifyError('O tamanho do arquivo não pode ser superior a 3 mb.');
      this.nomeArquivo = '';
      this.anexo = new ArquivoInscricao();
      this.arquivo = null;
    } else if (!(this.arquivo.type === 'image/png' || this.arquivo.type === 'image/jpg' || this.arquivo.type === 'image/jpeg' || this.arquivo.type === 'application/pdf')) {
      this.notificationService.notifyError('Somente arquivos com extensão .pdf são permitidos.');
      this.nomeArquivo = '';
      this.anexo = new ArquivoInscricao();
      this.arquivo = null;
    }
  }

  enviarArquivoSelecionado() {
    if (!this.arquivo) {
      return this.notificationService.notifyError('É necessário informar um arquivo!');
    }
    else if (!this.anexo.tipoArquivo) {
      return this.notificationService.notifyError('É necessário informar um tipo de arquivo!');
    }
    else {
      this.loading = true;
      this.anexo.itemConcurso = this.inscricao.itemConc;
      this.anexo.concurso = this.inscricao.concurso;
      this.anexo.numeroInscricao = this.inscricao.nrInscricao;
      this.arquivos.push(this.arquivo);

      forkJoin(
        this.publicacaoService.PostUploadFileCandidatoInscrito(this.anexo, this.arquivos),
      ).subscribe(resSub => {
        if (resSub[0] !== false) {
          this.nomeArquivo = '';
          this.anexo = new ArquivoInscricao();
          this.arquivo = null;
          this.arquivos = [];
          this.descricao = null;
          this.loading = false;
          this.getArquivosByCodigoInscricao();
          return this.notificationService.notifySuccess('Arquivo inserido com sucesso.');
        } else {
          this.nomeArquivo = '';
          this.anexo = new ArquivoInscricao();
          this.arquivo = null;
          this.arquivos = [];
          this.loading = false;
          return this.notificationService.notifyError('Erro ao tentar enviar o arquivo. o Concurso não existe.');
        }
      }, error => {
        this.nomeArquivo = '';
        this.anexo = new ArquivoInscricao();
        this.arquivo = null;
        this.arquivos = [];
        this.loading = false;
        throw error;
      });
    }
  }

  baixar(arquivo: ArquivoInscricao) {
    window.open(this.urlApiArquivo + arquivo.referenciaApi + '', '_blank');
  }

  onAction(event: { action: string; object: ArquivoInscricao }): void {
    switch (event.action) {
      case 'Baixar':
        this.baixar(event.object);
        break;
    }
  }

  GetFilter(event?: LazyLoadEvent): void {  }

  createElementFromHTML(htmlString) {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();    
    return div.firstChild;
  }

  setupTable(): void {
    this.columns = [
      {
        field: 'descricao',
        header: 'Arquivo',
        width: '60%'
      },
      {
        field: 'dataEnvio',
        header: 'Data/Hora do Envio',

        valueDisplayFn: data => new Date(data).toLocaleDateString() + ' ' + new Date(data).toLocaleTimeString()
      },
    ];
    this.actions = [
      { title: 'Baixar', icon: 'glyphicon glyphicon-save-file', isHidden: (value: any) => { return this.isFormTypeView } },
    ];
  }

  voltar(): void {
    this.routeDataService.toAcompanhamentoInscricao();
  }

  handleValidSubmission(form: NgForm): void {
    console.log('handleValidSubmission');
    this.enviarArquivoSelecionado();
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/candidato/candidato-enviar-arquivo/candidato-enviar-arquivo.component.ts